<template>
  <v-container
    fluid
    fill-height
  >
    <confirmation-dialog ref="confirm" />
    <v-row class="align-center justify-right">
      <v-col
        cols="6"
        md="3"
      >
        <search-field v-model="search" />
      </v-col>
      <v-spacer />
      <v-col
        cols="3"
        class="text-right"
      >
        <add-new-button
          title="Add client"
          @click="inviteClient"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <h2>Current clients</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :loading="associatedFirstPartiesLoading"
          :items="associatedFirstParties"
          :headers="clientHeaders"
          :search="search"
          no-data-text="No clients"
        >
          <template #[`item.type`]="{ item }">
            {{ accountTypeLabel(item.type) }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <h2>Pending invitations</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :loading="sentClientInvitationsLoading"
          :items="sentClientInvitations"
          :headers="invitationHeaders"
          :search="search"
          no-data-text="No pending invitations"
        >
          <template #[`item.resend`]="{ item }">
            <v-btn
              color="primary"
              :loading="isReminding(item)"
              small
              @click="sendReminder(item)"
            >
              Send reminder
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog
      v-model="invitingClient"
      max-width="500px"
    >
      <invite-client-form
        @cancel="invitingClient = false"
        @invited="invitingClient = false"
      />
    </v-dialog>
  </v-container>
</template>
<script>
import { getAccountType } from '../dataAccess/accountTypes'
import AddNewButton from '@/components/AddNewButton'
import SearchField from '@/components/SearchField'
import InviteClientForm from '@/components/InviteClientForm'
import ConfirmationDialog from '@/components/ConfirmationDialog.vue'
import { asRecordId } from '../dataAccess/queries'

export default {
  name: 'ManageClients',
  components: {
    AddNewButton,
    ConfirmationDialog,
    InviteClientForm,
    SearchField
  },
  data: function () {
    return {
      invitingClient: false,
      reminding: {},
      search: null,
      clientHeaders: [
        {
          text: 'Name',
          value: 'name',
          filterable: true,
          sortable: true
        },
        {
          text: 'Type',
          value: 'type',
          filterable: true,
          sortable: true
        }
      ],
      invitationHeaders: [
        {
          text: 'Name',
          value: 'name',
          filterable: true,
          sortable: true
        },
        {
          text: 'Email',
          value: 'email',
          filterable: true,
          sortable: true
        },
        {
          value: 'resend',
          filterable: false,
          sortable: false
        }
      ]
    }
  },
  beforeCreate() {
    this.mapStates(['associatedFirstParties', 'associatedFirstPartiesLoading', 'sentClientInvitations', 'sentClientInvitationsLoading'])
    this.dispatchActions(['get_associatedFirstParties'])
    this.$store.dispatch('get_sentClientInvitations').then(() => {
      this.reminding = this.sentClientInvitations.reduce((acc, invite) => {
        acc[asRecordId(invite)] = false
        return acc
      }, {})
    })
  },
  methods: {
    accountTypeLabel(accountTypeId) {
      return getAccountType(accountTypeId).label
    },
    inviteClient() {
      this.invitingClient = true
    },
    async sendReminder(invite) {
      const name = invite.name
      if (
        await this.$refs.confirm.open(
          'Send reminder?',
          `"${name} will receive another email reminding them about your invitation.`,
          { type: 'info' }
        )
      ) {
        this.setReminding(invite, true)
        this.$handlingError(
          `Error sending reminder to "${name}"`,
          async () => {
            await this.$api.sendClientInvitationReminder(invite)
            this.$showSuccessbar(`Reminder sent for "${name}"`)
          },
          { final: () => this.setReminding(invite, false) }
        )
      }
    },
    isReminding(invite) {
      return this.reminding[asRecordId(invite)]
    },
    setReminding(invite, value) {
      this.reminding[asRecordId(invite)] = value
    }
  }
}
</script>
